import defaultSettings from '@/settings'

const title = defaultSettings.title || '耳尖舆情数据系统'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
